/* eslint-disable no-undef */
import React, { Suspense } from "react";
import Loading from "../components/Loading";

function loadComponent(scope, module) {
  return async () => {
    // @ts-ignore
    await __webpack_init_sharing__("default");
    const container = window[scope]; // or get the container somewhere else
    // Initialize the container, it may provide shared modules
    await container.init(__webpack_share_scopes__.default);
    const factory = await window[scope].get(module);
    const Module = factory();

    return Module;
  };
}

const useDynamicScript = (args) => {
  const [ready, setReady] = React.useState(false);
  const [failed, setFailed] = React.useState(false);

  React.useEffect(() => {
    if (!args.url) {
      return;
    }

    const element = document.createElement("script");

    element.src = args.url;
    element.type = "text/javascript";
    element.async = true;

    setReady(false);
    setFailed(false);

    element.onload = () => {
      console.log(`Dynamic Script Loaded: ${args.url}`);
      setReady(true);
    };

    element.onerror = () => {
      console.error(`Dynamic Script Error: ${args.url}`);
      setReady(false);
      setFailed(true);
    };

    document.head.appendChild(element);

    return () => {
      console.log(`Dynamic Script Removed: ${args.url}`);
      document.head.removeChild(element);
    };
  }, [args.url]);

  return {
    ready,
    failed,
  };
};

export function System(props) {
  const { ready, failed } = useDynamicScript({
    url: props.system && props.system.url,
  });

  if (!props.system) {
    return <h2>Not system specified</h2>;
  }

  if (failed) {
    window.newrelic.addPageAction("Unavailable service", {
      // eslint-disable-next-line no-restricted-globals
      service: props.system.title,
      timestamp: Date.now(),
    });
    return <h2>Ops.. Serviço {props.system.title} indisponível</h2>;
  }

  if (!ready) {
    return <Loading />;
  }
  const Component = React.lazy(
    loadComponent(props.system.scope, props.system.module)
  );
  return (
    <Suspense fallback={<Loading />}>
      <Component />
    </Suspense>
  );
}
